module.exports = __webpack_public_path__ + "static/media/couches-15.ab4b2842.jpg";